export const WS_CLIENT_KEEP_ALIVE = 580000; // 9m 40 - timeframe needed for UCT token refresh: https://developer.atlassian.com/platform/graphql-gateway/subscriptions/security/#long-lived-user-context-token
// 30s also satisfies the UCT refresh window, and keeps the socket under the 60-120s idle timeout
// common to load balancers and corporate proxies.
export const WS_CLIENT_LIVENESS_KEEP_ALIVE = 30000;
// Half the ping interval, so a dead socket is detected within 45s at worst. graphql-ws enqueues
// the next ping only on pong, so exactly one ping goes unanswered before this fires.
export const WS_CLIENT_PONG_WAIT = 15000;
// Long enough not to cut off a slow but working handshake. Closes with 4504, which graphql-ws
// treats as retryable.
export const WS_CLIENT_CONNECTION_ACK_WAIT = 15000;
export const WS_CLIENT_RETRIES = 100;
// graphql-ws's backoff is uncapped - 1s doubling per retry - so the eleventh retry is a quarter
// of an hour away and everything past roughly the twelfth is unreachable in a session.
export const WS_CLIENT_MAX_RETRY_WAIT = 30000;
// Sized to the cap above, which is what makes a budget spendable at all: at a 30s ceiling
// WS_CLIENT_RETRIES would be gone in under an hour, after which the client gives up permanently.
// 240 covers about two hours of continuous failure.
export const WS_CLIENT_CAPPED_RETRIES = 240;
export const WS_CLOSE_ON_IDLE = 300000; // 5m
